"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoChatCubbyHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _ = require("../..");
var _components = require("../../../components");
var _utils = require("../../../utils");
var _VideoChatCubbyContext = require("../VideoChatCubbyContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var VideoChatCubbyHeader = function VideoChatCubbyHeader() {
  var _useVideoChatCubby = (0, _VideoChatCubbyContext.useVideoChatCubby)(),
    patient = _useVideoChatCubby.patient,
    booking = _useVideoChatCubby.booking;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;

  // NOTE: possible for header to have 2 rows if patient has long name
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full px-[20px] py-[12px] flex flex-wrap justify-start items-center gap-y-[4px] gap-x-[24px]"
  }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Patient name: "), /*#__PURE__*/_react.default.createElement(_components.TextButton, {
    size: "small",
    route: "/patients/".concat(patient === null || patient === void 0 ? void 0 : patient.nickName)
  }, (0, _utils.personName)(patient))), !(0, _lodash.isEmpty)(booking) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Appointment date: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _momentTimezone.default)(booking.startsAt).tz(user.profile.timeZone).format('M.D.YYYY'))), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-light"
  }, "Start time: "), /*#__PURE__*/_react.default.createElement("span", {
    className: "tw-body-sm-medium"
  }, (0, _momentTimezone.default)(booking.startsAt).tz(user.profile.timeZone).format('h:mma'))))), /*#__PURE__*/_react.default.createElement(_components.Divider, {
    className: "border-grey-15"
  }));
};
exports.VideoChatCubbyHeader = VideoChatCubbyHeader;